import { ChangeDetectionStrategy, Component, inject } from '@angular/core';
import { Answer } from '@app/core/models';
import { PopoverRef, SHARED_MODULES } from '@app/shared';
import { ModalReviewService } from './modal-review.service';
import { combineLatest, map, Observable } from 'rxjs';

@Component({
  selector: 'app-modal-review-popover-answers',
  imports: [SHARED_MODULES],
  templateUrl: './modal-review-popover-answers.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ModalReviewPopoverAnswersComponent {
  private readonly _popoverRef = inject<PopoverRef<Answer>>(PopoverRef);
  private readonly _modalReviewService = inject(ModalReviewService);
  public answers$: Observable<Answer[]>;

  constructor() {
    this.answers$ = combineLatest({
      studentId: this._modalReviewService.studentId$,
      answers: this._modalReviewService.answers$,
    }).pipe(map(({ studentId, answers }) => answers?.filter((answer) => +answer.student_id === +studentId)));
  }

  public onSelect(answer: Answer) {
    this._popoverRef.close(answer);
  }
}
